export default "__VITE_ASSET__DdWzj2Lb__"